'use client';

import Link from 'next/link';
import Image from 'next/image';

interface HeaderProps {
  showBackButton?: boolean;
  backHref?: string;
  title?: string;
}

const Header = ({ showBackButton = false, backHref = '/', title }: HeaderProps) => {
  return (
    <header className="fixed w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Izquierda como en CFO Ecuador */}
          <div className="flex items-center">
            <Link 
              href="/"
              className="flex items-center relative overflow-hidden focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-white p-2"
            >
              {/* Logo solo texto (visible por defecto) */}
              <Image
                src="/images/LOGO_ISOTIPO_MORADO.png"
                alt="CFO Ecuador"
                width={160}
                height={64}
                className="h-16 w-auto object-contain"
                priority
              />
            </Link>
          </div>

          {/* Navegación - Derecha como en CFO Ecuador */}
          <nav className="hidden md:flex items-center space-x-8">
            {showBackButton && (
              <Link 
                href={backHref}
                className="inline-flex items-center text-navy text-sm font-medium"
                aria-label="Volver"
              >
                <svg 
                  className="w-4 h-4 mr-2" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M15 19l-7-7 7-7" 
                  />
                </svg>
                Volver
              </Link>
            )}
            
            <Link 
              href="/" 
              className="text-navy text-sm font-medium"
            >
              Inicio
            </Link>
            
            <Link 
              href="/cuestionario" 
              className="text-navy text-sm font-medium"
            >
              Evaluación
            </Link>
            
            {title && (
              <span className="text-accent text-sm font-semibold px-3 py-1 bg-accent/10 rounded-full">
                {title}
              </span>
            )}
          </nav>

          {/* Menú móvil */}
          <div className="md:hidden flex items-center space-x-4">
            {showBackButton && (
              <Link 
                href={backHref}
                className="inline-flex items-center text-gray-100"
                aria-label="Volver"
              >
                <svg 
                  className="w-5 h-5" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M15 19l-7-7 7-7" 
                  />
                </svg>
              </Link>
            )}
            
            {title && (
              <span className="text-accent text-xs font-semibold px-2 py-1 bg-accent/10 rounded-full">
                {title}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
